"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
/**
 * Utilities for working with the Document Object Model (DOM).
 * @module DOMUtils
 */
const DOMUtils = {
  /**
   * Get the height of the specified element.
   * @static
   * @function height
   * @param {String} selector - The element selector to find the height of.
   * @param {Boolean} [includeMargin=true] - Whether to include the margins in the calculation effectively getting the outerHeight.
   * @param {Boolean} [includePadding=true] - Whether to include the padding in the calculation.
   * @example
   * DOMUtils.height('.foo');
   * @returns {Number} - The height of the element.
   */
  height(selector) {
    let includeMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let includePadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const el = document.querySelector(selector);
    if (!el) {
      return 0;
    }
    const {
      marginTop,
      marginBottom,
      paddingTop,
      paddingBottom
    } = getComputedStyle(el);
    let height = el.offsetHeight;
    if (includeMargin) {
      height += parseInt(marginTop, 10) + parseInt(marginBottom, 10);
    }
    if (!includePadding) {
      height -= parseInt(paddingTop, 10) + parseInt(paddingBottom, 10);
    }
    return height;
  },
  /**
   * Get the width of the specified element.
   * @static
   * @function width
   * @param {String} selector - The element selector to find the width of.
   * @param {Boolean} [includeMargin=true] - Whether to include the margins in the calculation effectively getting the outerWidth.
   * @param {Boolean} [includePadding=true] - Whether to include the padding in the calculation.
   * @example
   * DOMUtils.width('.foo');
   * @returns {Number} - The width of the element.
   */
  width(selector) {
    let includeMargin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    let includePadding = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const el = document.querySelector(selector);
    if (!el) {
      return 0;
    }
    const {
      marginLeft,
      marginRight,
      paddingLeft,
      paddingRight
    } = getComputedStyle(el);
    let width = el.offsetWidth;
    if (includeMargin) {
      width += parseInt(marginLeft, 10) + parseInt(marginRight, 10);
    }
    if (!includePadding) {
      width -= parseInt(paddingLeft, 10) + parseInt(paddingRight, 10);
    }
    return width;
  },
  /**
   * Loads a script into an element in the document if it hasn't already been loaded. Pass a fully qualified, exact URL to enable proper matching against a pre-existing script of the same path.
   * @static
   * @function loadScript
   * @param {String} src - The exact script path to load.
   * @param {String} [appendTo='head'] - Where to append the script ('head', 'body') in the document.
   * @example
   * DOMUtils.loadScript({src: 'https://js.stripe.com/v3/'});
   * @returns {Promise} - The promise that is either fulfilled or rejected as a result of loading the script.
   */
  loadScript(_ref) {
    let {
      src,
      appendTo = 'head'
    } = _ref;
    const isDuplicate = [...document.querySelectorAll('script')].some(script => script.src === src);
    if (isDuplicate) {
      return Promise.resolve();
    } else {
      return new Promise((resolve, reject) => {
        const s = document.createElement('script');
        s.src = src;
        s.onload = resolve;
        s.onerror = reject;
        document[appendTo].appendChild(s);
      });
    }
  }
};
var _default = DOMUtils;
exports.default = _default;